<script lang="ts">
	import { twMerge } from 'tailwind-merge';
	import type { VerticalScrollState } from '../../utils/verticalScrollHint/verticalScrollHint';

	interface Props {
		dataCy: string;
		scrollState: VerticalScrollState;
	}

	let { dataCy, scrollState }: Props = $props();
</script>

<!-- Scroll shadows: fade in only when content extends past that edge, so it's
     discoverable that more content lies above/below the fold. The parent must
     be `position: relative` and wrap the scrollable node. -->
<div
	aria-hidden="true"
	data-cy={`${dataCy}-scroll-hint-top`}
	class={twMerge(
		'pointer-events-none absolute inset-x-0 top-0 h-8 bg-gradient-to-b from-gray-900/10 to-transparent opacity-0 transition-opacity duration-200',
		scrollState.canScroll && !scrollState.atTop && 'opacity-100'
	)}
></div>
<div
	aria-hidden="true"
	data-cy={`${dataCy}-scroll-hint-bottom`}
	class={twMerge(
		'pointer-events-none absolute inset-x-0 bottom-0 h-8 bg-gradient-to-t from-gray-900/10 to-transparent opacity-0 transition-opacity duration-200',
		scrollState.canScroll && !scrollState.atBottom && 'opacity-100'
	)}
></div>
